import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-info align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-info3 icon-2x" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", { class: "font-italic ml-3" }, "Keine verfügbaren Anlage zur Übernahme von Kontakten", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "card"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Wählen Sie die Anlage welche übernommen werden soll")
], -1)
const _hoisted_10 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-siren" })
  ])
], -1)
const _hoisted_13 = { class: "media-body d-flex flex-row align-items-center" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    (_ctx.systems.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (system, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createElementVNode("a", {
                  class: "media cursor-pointer",
                  onClick: ($event: any) => (_ctx.chooseSystem(system.anlage_id))
                }, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(system.anlage_bemerkung) + " ", 1),
                      _createElementVNode("div", _hoisted_15, "Nummer: " + _toDisplayString(system.anlage_nummer), 1)
                    ])
                  ]),
                  _hoisted_16
                ], 8, _hoisted_11)
              ]))
            }), 128))
          ])
        ]))
  ]))
}